export default "__VITE_ASSET__iJb5yx0i__"